<template>
  <div class="reset-split-page">
    <ServerError v-if="ServerError" />

    <v-snackbar v-model="showSnackBar" :color="snackColor" top right :timeout="timeout">
      <span style="color: #FFFFFF; font-weight: 600;">{{ msg }}</span>
      <template v-slot:action="{ attrs }">
        <v-btn text color="#FFFFFF" v-bind="attrs" @click="showSnackBar = false">
          <v-icon style="color: #FFFFFF">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <div class="reset-card-container">
      <div class="reset-ornament-header">
        <div class="ornament-line"></div>
        <div class="ornament-diamond-box">
          <svg viewBox="0 0 100 100" class="mini-diamond-svg">
            <polygon points="50,12 85,38 50,88 15,38" fill="none" stroke="#9E6D2B" stroke-width="5" stroke-linejoin="round" />
            <line x1="15" y1="38" x2="85" y2="38" stroke="#9E6D2B" stroke-width="4" />
          </svg>
        </div>
        <div class="ornament-line"></div>
      </div>

      <div class="reset-form-wrapper">
        <div class="welcome-kicker">SECURITY STEP</div>
        <h2 class="reset-title">Set a New Password</h2>
        <p class="reset-subtext">
          You're signing in with a temporary password. Choose a new password to continue.
        </p>

        <v-form @submit.prevent="submit" class="reset-v-form">
          <div class="input-field-wrap mb-4">
            <label class="field-label">Current (Temporary) Password</label>
            <v-text-field
              v-model="currentPassword"
              prepend-inner-icon="mdi-lock-outline"
              :append-icon="showCurrent ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showCurrent ? 'text' : 'password'"
              @click:append="showCurrent = !showCurrent"
              placeholder="Enter the temporary password"
              outlined
              dense
              hide-details
              class="bright-custom-input"
            ></v-text-field>
          </div>

          <div class="input-field-wrap mb-4">
            <label class="field-label">New Password</label>
            <v-text-field
              v-model="newPassword"
              prepend-inner-icon="mdi-lock-plus-outline"
              :append-icon="showNew ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showNew ? 'text' : 'password'"
              @click:append="showNew = !showNew"
              placeholder="At least 6 characters"
              outlined
              dense
              hide-details
              class="bright-custom-input"
            ></v-text-field>
          </div>

          <div class="input-field-wrap mb-5">
            <label class="field-label">Confirm New Password</label>
            <v-text-field
              v-model="confirmPassword"
              prepend-inner-icon="mdi-lock-check-outline"
              :type="showNew ? 'text' : 'password'"
              placeholder="Re-enter the new password"
              outlined
              dense
              hide-details
              class="bright-custom-input"
              @keyup.enter="submit"
            ></v-text-field>
          </div>

          <button type="button" class="reset-btn-gold" @click="submit">
            Update Password <span class="btn-arrow-symbol">→</span>
          </button>
        </v-form>

        <div class="logout-link" @click="logout">Log out instead</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "./../../store";

export default {
  name: "ResetPassword",
  data() {
    return {
      ServerError: false,
      showSnackBar: false,
      snackColor: "#9E6D2B",
      timeout: 5000,
      msg: null,
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      showCurrent: false,
      showNew: false,
    };
  },
  methods: {
    notify(msg, isError) {
      this.msg = msg;
      this.snackColor = isError ? "#B3261E" : "#9E6D2B";
      this.showSnackBar = true;
    },
    submit() {
      if (!this.currentPassword) {
        this.notify("Please enter your current (temporary) password", true);
        return;
      }
      if (!this.newPassword || this.newPassword.length < 6) {
        this.notify("New password must be at least 6 characters", true);
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        this.notify("New password and confirmation do not match", true);
        return;
      }
      if (this.newPassword === this.currentPassword) {
        this.notify("New password must be different from the temporary password", true);
        return;
      }

      store.commit("appLoading", true);
      axios({
        method: "POST",
        url: "/user/change/password",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          password: this.currentPassword,
          newpassword: this.newPassword,
        },
      })
        .then((response) => {
          store.commit("appLoading", false);
          if (response.data.status) {
            store.commit("mustChangePassword", false);
            this.notify("Password updated successfully", false);
            var role = localStorage.getItem("role");
            if (role === "SuperAdmin") {
              this.$router.push("/superadminDashboard");
            } else if (role === "JewelleryAdmin") {
              this.$router.push("/JewelleryDashboard");
            } else {
              this.$router.push("/StaffDashboard");
            }
          } else {
            this.notify(response.data.msg || "Could not update password", true);
          }
        })
        .catch((err) => {
          store.commit("appLoading", false);
          this.ServerError = true;
          console.log(err);
        });
    },
    logout() {
      store.commit("logoutUser");
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600&family=Cormorant+Garamond:wght@500;600&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');

.reset-split-page {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  background-color: #FAF7F2;
  background-image:
    radial-gradient(circle at 15% 15%, rgba(245, 235, 220, 0.9) 0%, transparent 45%),
    radial-gradient(circle at 85% 85%, rgba(238, 222, 200, 0.7) 0%, transparent 55%);
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
}

.reset-card-container {
  width: 100%;
  max-width: 430px;
  border-radius: 24px;
  padding: clamp(28px, 4vh, 44px) clamp(24px, 3vw, 40px);
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(24px) saturate(180%);
  -webkit-backdrop-filter: blur(24px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.9);
  box-shadow:
    0 25px 50px -12px rgba(30, 24, 21, 0.1),
    0 8px 24px rgba(158, 109, 43, 0.06);
}

.reset-ornament-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 20px;
}

.ornament-line {
  flex: 1;
  max-width: 70px;
  height: 1.5px;
  background-color: #D1B896;
}

.ornament-diamond-box {
  width: 24px;
  height: 24px;
}

.mini-diamond-svg {
  width: 100%;
  height: 100%;
}

.reset-form-wrapper {
  text-align: center;
}

.welcome-kicker {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2.5px;
  color: #9E6D2B;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.reset-title {
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-size: clamp(26px, 3vw, 32px);
  font-weight: 600;
  color: #1E1815;
  margin-bottom: 8px;
  line-height: 1.15;
}

.reset-subtext {
  font-size: 13px;
  color: #6E6358;
  margin-bottom: 24px;
}

.reset-v-form {
  text-align: left;
}

.input-field-wrap {
  display: flex;
  flex-direction: column;
}

.field-label {
  font-size: 12.5px;
  font-weight: 600;
  color: #383028;
  margin-bottom: 5px;
}

.bright-custom-input >>> .v-input__slot {
  background-color: rgba(255, 255, 255, 0.75) !important;
  border: 1px solid rgba(226, 215, 199, 0.85) !important;
  border-radius: 12px !important;
  min-height: 46px !important;
  padding: 0 14px !important;
}

.bright-custom-input.v-input--is-focused >>> .v-input__slot {
  border-color: #9E6D2B !important;
  box-shadow: 0 0 0 3px rgba(158, 109, 43, 0.14) !important;
}

.bright-custom-input >>> .v-icon {
  color: #9E6D2B !important;
  font-size: 20px !important;
}

.reset-btn-gold {
  width: 100%;
  height: 48px;
  background: linear-gradient(135deg, #B58238 0%, #905F1E 100%);
  color: #FFFFFF;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(158, 109, 43, 0.24);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.reset-btn-gold:hover {
  background: linear-gradient(135deg, #C28F43 0%, #9B6925 100%);
}

.btn-arrow-symbol {
  font-size: 18px;
}

.logout-link {
  margin-top: 18px;
  font-size: 13px;
  font-weight: 600;
  color: #8C7D6F;
  cursor: pointer;
  text-decoration: underline;
}
</style>
